"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleScheduleSummary = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Tag_1 = require("../../../components/Tag");
const UIHelper_1 = require("../../UIHelper");
const OnePageAdaptableWizard_1 = require("../../Wizard/OnePageAdaptableWizard");
const ScheduleScheduleSummary = () => {
    const { data } = (0, OnePageAdaptableWizard_1.useOnePageAdaptableWizardContext)();
    return (React.createElement(OnePageAdaptableWizard_1.SummaryText, null,
        "Schedule: ",
        React.createElement(Tag_1.Tag, null, UIHelper_1.UIHelper.getScheduleDescription(data.Schedule))));
};
exports.ScheduleScheduleSummary = ScheduleScheduleSummary;
